import { render, staticRenderFns } from "./linkAutocomplete.vue?vue&type=template&id=1b89357f&scoped=true"
import script from "./linkAutocomplete.vue?vue&type=script&lang=js"
export * from "./linkAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89357f",
  null
  
)

export default component.exports